import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateCouncilStats = (state: StatsSnapshot) => {
  const council = state.generators.council;

  const generatedGarrisons = council.owned * council.baseGeneration;

  stats.council = {
    buildingsGeneration: generatedGarrisons,
  };
};
